import type { GlossaryTerm } from '@/types/glossary'; // created in Phase G

export interface GlossaryHit {
  term: string;
  preserve_as_is: boolean;
  translation?: string;
}

/** Whole-word case-insensitive scan. */
export function findGlossaryHits(
  source: string,
  terms: GlossaryTerm[],
  targetLang: string,
): GlossaryHit[] {
  const out: GlossaryHit[] = [];
  for (const t of terms) {
    const re = new RegExp(`\\b${escapeRegExp(t.term)}\\b`, 'i');
    if (re.test(source)) {
      const trans = t.translations.find((x) => x.lang_code === targetLang);
      out.push({ term: t.term, preserve_as_is: t.preserve_as_is, translation: trans?.translation });
    }
  }
  return out;
}

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
